import { getCurrency } from '../../../../cache';
import { Money } from '../../../../types';
import { addMoney } from './addMoney';
import { getZeroPrice } from './getZeroPrice';
import { reduceMoney } from './reduceMoney';

export const getTotalPrice = <T>(items: T[], getItemPrice: (item: T) => Money | null | undefined): Money => {
	if (!items?.length) {
		return getZeroPrice();
	}

	const total = reduceMoney(
		items,
		getItemPrice,
		(acc, price) => addMoney(acc, { amount: price.amount || 0, currency: price.currency }),
		{ amount: 0, currency: null }
	);

	return { ...total, currency: total.currency ?? getCurrency() };
};
